(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arn-global-banner"] && !Shopify.designMode) return;
  try {
    
  class ArnGlobalBanner extends HTMLElement {
    constructor() {
      super();

      window.addEventListener('resize', () => {
        this.setBannerHeight();
      });
    }

    connectedCallback() {
      this.setBannerHeight();
      this.slider = this.querySelector('arn-swiper');
      if (!this.slider) return;
      this.events = new AbortController();
      this.slider.addEventListener('swiper:afterInit', () => this.setupCarousel(), { signal: this.events.signal });
      if (this.slider.swiper?.initialized) this.setupCarousel();
    }

    setupCarousel() {
      this.swiper = this.slider.swiper;
      this.status = this.querySelector('[data-announcement-status]');
      this.rotation = this.querySelector('[data-rotation-control]');
      const options = { signal: this.events.signal };
      const stop = () => {
        this.swiper.autoplay?.stop();
        this.updateRotation();
      };
      this.slider.addEventListener('focusin', stop, options);
      this.slider.addEventListener('mouseenter', stop, options);
      this.slider.addEventListener('click', (event) => {
        if (event.target.closest('button[name="next"], button[name="previous"]')) stop();
      }, { ...options, capture: true });
      // Preserve the pointer's intended action before focusin stops rotation.
      this.rotation?.addEventListener('pointerdown', () => {
        this.wasRotating = this.swiper.autoplay.running;
      }, options);
      this.rotation?.addEventListener('click', (event) => {
        const wasRotating = event.detail ? this.wasRotating : this.swiper.autoplay.running;
        if (wasRotating) stop();
        else this.swiper.autoplay.start();
        this.status.textContent = '';
        this.updateRotation();
      }, options);
      this.onSlideChange = () => this.updateSlide(true);
      // Loop/resize can change the slide without transition callbacks.
      this.swiper.on('realIndexChange', this.onSlideChange);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || this.contains(document.activeElement)) stop();
      this.updateSlide(false);
      this.updateRotation();
    }

    updateSlide(announce) {
      const active = this.swiper.slides[this.swiper.activeIndex];
      // Scheduling removes ineligible blocks before initialization. Swiper's loop
      // reorders the DOM, so number the remaining slides by their logical index.
      const slides = [...this.swiper.slides].sort((a, b) =>
        Number(a.getAttribute('data-swiper-slide-index')) - Number(b.getAttribute('data-swiper-slide-index'))
      );
      slides.forEach((slide, index) => {
        slide.setAttribute('aria-label', `${index + 1} ${this.dataset.ofLabel} ${slides.length}`);
        slide.inert = slide !== active;
        slide.setAttribute('aria-hidden', String(slide !== active));
      });
      if (announce && active && !this.swiper.autoplay?.running) {
        const content = active.textContent.replace(/\s+/g, ' ').trim();
        const hasInteractiveContent = getFocusableElements(active).some(element =>
          !element.closest('[hidden], [inert], [aria-hidden="true"]')
        );
        const hint = hasInteractiveContent ? `${this.dataset.interactiveContentLabel} ` : '';
        this.status.textContent = `${this.dataset.slideLabel} ${active.getAttribute('aria-label')}: ${hint}${content}`;
      }
    }

    updateRotation() {
      if (!this.rotation) return;
      const running = this.swiper.autoplay.running;
      this.rotation.setAttribute('aria-label', running ? this.rotation.dataset.pauseLabel : this.rotation.dataset.playLabel);
      this.rotation.firstElementChild.textContent = running ? 'Ⅱ' : '▶';
    }

    disconnectedCallback() {
      this.events?.abort();
      this.swiper?.off('realIndexChange', this.onSlideChange);
    }

    setBannerHeight() {
      document.documentElement.style.setProperty('--arn-global-banner-height', `${this.offsetHeight}px`);
    }
  }
  customElements.define('arn-global-banner', ArnGlobalBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arn-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('arn-dialog');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arn-service-bar"] && !Shopify.designMode) return;
  try {
    
  class ArnServiceBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setBarHeight();
    }

    setBarHeight() {
      document.documentElement.style.setProperty('--arn-service-bar-height', `${this.offsetHeight}px`);
    }
  }
  customElements.define('arn-service-bar', ArnServiceBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
